module.exports = __webpack_public_path__ + "img/car.a36f8554.png";